import { SubscriberId } from "../dbot/increaseOfShareCapital/increaseOfShareCapitalDomain";
import { CompanyroleId } from "../types/CompanyInfo";

export type BoardMeetingReference = { type: "bm"; projectId: string };
export type CompanyroleIdReference = { type: "companyroleId"; id: CompanyroleId };
export type ShareholderIdReference = { type: "shareholderId"; id: number };
export type DecisionIdReference = { type: "decisionId"; id: string };
export type DocumentIdReference = { type: "documentId"; id: string };
export type GeneralMeetingReference = { type: "gm"; projectId: string };
export type GeneralMeetingReminderReference = { type: "gm:reminder"; projectId: string };
export type ProjectReference = { type: "project"; id: string };
export type SubscriberIdReference = { type: "subscriberId"; id: SubscriberId };
export type UserReference = { type: "user"; id: string };
export type RecipientReference = { type: "recipientId"; id: string };

export type UrnReference =
  | BoardMeetingReference
  | CompanyroleIdReference
  | ShareholderIdReference
  | DecisionIdReference
  | DocumentIdReference
  | GeneralMeetingReference
  | GeneralMeetingReminderReference
  | ProjectReference
  | SubscriberIdReference
  | UserReference
  | RecipientReference;

const urnReferenceRegex = /^urn:(.*):(.*)$/;

export const resolveUrnReference = (s: string | null | undefined): UrnReference | undefined => {
  const [, type, value]: string[] = urnReferenceRegex.exec(s ?? "") ?? [];
  switch (type) {
    case "bm":
      return { type: "bm", projectId: value };
    case "companyroleId":
      return { type: "companyroleId", id: parseInt(value) };
    case "shareholderId":
      return { type: "shareholderId", id: parseInt(value) };
    case "decisionId":
      return { type: "decisionId", id: value };
    case "documentId":
      return { type: "documentId", id: value };
    case "gm":
      return { type: "gm", projectId: value };
    case "gm:reminder":
      return { type: "gm:reminder", projectId: value };
    case "project":
      return { type: "project", id: value };
    case "subscriberId":
      return { type: "subscriberId", id: value };
    case "user":
      return { type: "user", id: value };
    case "recipientId":
      return { type: "recipientId", id: value };
  }
};

export const urnReferenceToStringValue = (ref: UrnReference): string => {
  switch (ref.type) {
    case "bm":
      return `urn:bm:${ref.projectId}`;
    case "companyroleId":
      return `urn:companyroleId:${ref.id}`;
    case "shareholderId":
      return `urn:shareholderId:${ref.id}`;
    case "decisionId":
      return `urn:decisionId:${ref.id}`;
    case "documentId":
      return `urn:documentId:${ref.id}`;
    case "gm":
      return `urn:gm:${ref.projectId}`;
    case "gm:reminder":
      return `urn:gm:reminder:${ref.projectId}`;
    case "project":
      return `urn:project:${ref.id}`;
    case "subscriberId":
      return `urn:subscriberId:${ref.id}`;
    case "user":
      return `urn:user:${ref.id}`;
    case "recipientId":
      return `urn:recipientId:${ref.id}`;
  }
};

export function toSubscriberIdReference(subscriberId: SubscriberId) {
  return `urn:subscriberId:${subscriberId}`;
}

export function toCompanyRoleReference(companyroleId: CompanyroleId) {
  return `urn:companyroleId:${companyroleId}`;
}

export function toShareholderReference(shareholderId: number) {
  return `urn:shareholderId:${shareholderId}`;
}

export function toProjectReference(projectId: string) {
  return `urn:project:${projectId}`;
}

export function toUserReference(externalId: string) {
  return `urn:user:${externalId}`;
}

export function toDocumentReference(documentId: string) {
  return `urn:documentId:${documentId}`;
}
